/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const documentStatusService = {
  getList: (params: any) =>
    request.get('/guidebook/document-status', { params }),
  getDocumentStatusById: (id: any) =>
    request.get(`/guidebook/document-status/${id}`),
  createDocumentStatus: (data: any) =>
    request.post('/guidebook/document-status', data),
  deleteDocumentStatus: (id: any) =>
    request.delete(`/guidebook/document-status/${id}`),
  updateDocumentStatus: (id: any, data: any) =>
    request.put(`/guidebook/document-status/${id}`, data)
};

export default documentStatusService;
